// extracted by mini-css-extract-plugin
export var centerText = "_f5-8";
export var container = "_f5-0";
export var doughnutContainer = "_f5-7";
export var legend = "_f5-a";
export var legendItemColorDisplay = "_f5-b";
export var legendItemLabel = "_f5-d";
export var legendItemValue = "_f5-c";
export var lg = "_f5-5";
export var maxWidth = "_f5-9";
export var md = "_f5-4";
export var responsive = "_f5-6";
export var sm = "_f5-3";
export var xs = "_f5-2";
export var xxs = "_f5-1";